import { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import ReactPhoneInput from "react-phone-number-input/input";

import { NAMESPACES } from "@/constants/i18next.constants";

type PhoneInputProps = {
  placeholder?: string;
};

// NOTE: onChange react-hook-form ile kullanıldığı için burada kullanılmamıştır.
const PhoneInput = forwardRef<HTMLInputElement, PhoneInputProps>(({ placeholder, ...rest }, ref) => {
  const { t } = useTranslation(NAMESPACES.COMPONENTS);

  return (
    <ReactPhoneInput
      className="ant-input ant-input-sm ant-input-outlined"
      placeholder={placeholder || t("phoneInput.placeholder")}
      defaultCountry="TR"
      onChange={() => {}}
      ref={ref}
      {...rest}
    />
  );
});

export default PhoneInput;
